import { render, staticRenderFns } from "./work-order-instructions.html?vue&type=template&id=552cf558&scoped=true&"
import script from "./work-order-instructions.ts?vue&type=script&lang=js&"
export * from "./work-order-instructions.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cf558",
  null
  
)

export default component.exports